import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getCalculateReport = createAsyncThunk('report/getCalculateReport',
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/general/file/report', { params: { ...formData } });
      if (data?.message) {
        return rejectWithValue(data.message);
      }
      return { data };
    } catch (error) {
      return rejectWithValue(error?.data.message);
    }
  });

export default getCalculateReport;
